/**
 * Supabase Auth — browser client.
 *
 * Used by Client Components ("use client") to read the current session,
 * trigger sign-in/sign-up forms (via server actions, mostly), and
 * subscribe to auth state changes.
 *
 * Uses the ANON key (not service_role) — RLS policies on `profiles` and
 * `wishlist_items` enforce per-user access.
 *
 * Env vars required (Vercel + .env.local):
 *   NEXT_PUBLIC_SUPABASE_URL
 *   NEXT_PUBLIC_SUPABASE_ANON_KEY
 */

import { createBrowserClient } from "@supabase/ssr";

export function createSupabaseBrowserClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
